/*
 * Automatically generated by generate-routes.ts.
 * Do not edit this file or add other files to this directory.
 */
import { getAuthHeadersForClientSessionToken, warnOnInsecureuserIdentifierKey, } from '../../../../lib/seam/connect/auth.js';
import { createClient } from '../../../../lib/seam/connect/client.js';
import { isSeamHttpOptionsWithApiKey, isSeamHttpOptionsWithClient, isSeamHttpOptionsWithClientSessionToken, isSeamHttpOptionsWithConsoleSessionToken, isSeamHttpOptionsWithPersonalAccessToken, SeamHttpInvalidOptionsError, } from '../../../../lib/seam/connect/options.js';
import { limitToSeamHttpRequestOptions, parseOptions, } from '../../../../lib/seam/connect/parse-options.js';
import { SeamHttpRequest } from '../../../../lib/seam/connect/seam-http-request.js';
import { SeamHttpClientSessions } from './client-sessions.js';
export class SeamHttpAcsCredentials {
    constructor(apiKeyOrOptions = {}) {
        const options = parseOptions(apiKeyOrOptions);
        this.client = 'client' in options ? options.client : createClient(options);
        this.defaults = limitToSeamHttpRequestOptions(options);
    }
    static fromClient(client, options = {}) {
        const constructorOptions = { ...options, client };
        if (!isSeamHttpOptionsWithClient(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing client');
        }
        return new SeamHttpAcsCredentials(constructorOptions);
    }
    static fromApiKey(apiKey, options = {}) {
        const constructorOptions = { ...options, apiKey };
        if (!isSeamHttpOptionsWithApiKey(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing apiKey');
        }
        return new SeamHttpAcsCredentials(constructorOptions);
    }
    static fromClientSessionToken(clientSessionToken, options = {}) {
        const constructorOptions = { ...options, clientSessionToken };
        if (!isSeamHttpOptionsWithClientSessionToken(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing clientSessionToken');
        }
        return new SeamHttpAcsCredentials(constructorOptions);
    }
    static async fromPublishableKey(publishableKey, userIdentifierKey, options = {}) {
        warnOnInsecureuserIdentifierKey(userIdentifierKey);
        const clientOptions = parseOptions({ ...options, publishableKey });
        if (isSeamHttpOptionsWithClient(clientOptions)) {
            throw new SeamHttpInvalidOptionsError('The client option cannot be used with SeamHttp.fromPublishableKey');
        }
        const client = createClient(clientOptions);
        const clientSessions = SeamHttpClientSessions.fromClient(client);
        const { token } = await clientSessions.getOrCreate({
            user_identifier_key: userIdentifierKey,
        });
        return SeamHttpAcsCredentials.fromClientSessionToken(token, options);
    }
    static fromConsoleSessionToken(consoleSessionToken, workspaceId, options = {}) {
        const constructorOptions = { ...options, consoleSessionToken, workspaceId };
        if (!isSeamHttpOptionsWithConsoleSessionToken(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing consoleSessionToken or workspaceId');
        }
        return new SeamHttpAcsCredentials(constructorOptions);
    }
    static fromPersonalAccessToken(personalAccessToken, workspaceId, options = {}) {
        const constructorOptions = { ...options, personalAccessToken, workspaceId };
        if (!isSeamHttpOptionsWithPersonalAccessToken(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing personalAccessToken or workspaceId');
        }
        return new SeamHttpAcsCredentials(constructorOptions);
    }
    async updateClientSessionToken(clientSessionToken) {
        const { headers } = this.client.defaults;
        const authHeaders = getAuthHeadersForClientSessionToken({
            clientSessionToken,
        });
        for (const key of Object.keys(authHeaders)) {
            if (headers[key] == null) {
                throw new Error('Cannot update a clientSessionToken on a client created without a clientSessionToken');
            }
        }
        this.client.defaults.headers = { ...headers, ...authHeaders };
        const clientSessions = SeamHttpClientSessions.fromClient(this.client);
        await clientSessions.get();
    }
    assign(body) {
        return new SeamHttpRequest(this, {
            path: '/acs/credentials/assign',
            method: 'post',
            body,
            responseKey: undefined,
        });
    }
    create(body) {
        return new SeamHttpRequest(this, {
            path: '/acs/credentials/create',
            method: 'post',
            body,
            responseKey: 'acs_credential',
        });
    }
    delete(body) {
        return new SeamHttpRequest(this, {
            path: '/acs/credentials/delete',
            method: 'post',
            body,
            responseKey: undefined,
        });
    }
    get(body) {
        return new SeamHttpRequest(this, {
            path: '/acs/credentials/get',
            method: 'post',
            body,
            responseKey: 'acs_credential',
        });
    }
    list(body) {
        return new SeamHttpRequest(this, {
            path: '/acs/credentials/list',
            method: 'post',
            body,
            responseKey: 'acs_credentials',
        });
    }
    listAccessibleEntrances(body) {
        return new SeamHttpRequest(this, {
            path: '/acs/credentials/list_accessible_entrances',
            method: 'post',
            body,
            responseKey: 'acs_entrances',
        });
    }
    unassign(body) {
        return new SeamHttpRequest(this, {
            path: '/acs/credentials/unassign',
            method: 'post',
            body,
            responseKey: undefined,
        });
    }
    update(body) {
        return new SeamHttpRequest(this, {
            path: '/acs/credentials/update',
            method: 'post',
            body,
            responseKey: undefined,
        });
    }
}
//# sourceMappingURL=acs-credentials.js.map